// import html2canvas from "html2canvas-pro";

// export const exportPowerPointCharts = async (chartRefs, questions) => {
//   // html2canvas can still be imported or you can use the global html2canvas
//   const pptx = new window.PptxGenJS();

//   for (let i = 0; i < chartRefs.current.length; i++) {
//     const chartEl = chartRefs.current[i];
//     const canvas = await window.html2canvas(chartEl, {
//       backgroundColor: "#fff",
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const slide = pptx.addSlide();
//     slide.addText(questions[i].question, {
//       x: 0.5,
//       y: 0.2,
//       fontSize: 14,
//       bold: true,
//     });
//     slide.addImage({
//       data: imgData,
//       x: 0.5,
//       y: 0.5,
//       w: pptx.presLayout.width - 1,
//       h: pptx.presLayout.height - 1,
//     });
//   }
//   await pptx.writeFile({ fileName: "SurveyCharts.pptx" });
// };
import { Button, Text } from "@chakra-ui/react";
import { useGeneratePowerpointMutation } from "../../store/services/mediaApi";

export function ExportPowerPointButton({ id, rank }) {
  const [queryGeneratePowerpoint, { data, isLoading, error }] =
    useGeneratePowerpointMutation();
  const handleDownload = async () => {
    try {
      const storedFilters = localStorage.getItem(`surveyFilters-${id}`);
      const filters = storedFilters ? JSON.parse(storedFilters) : [];
      const promo_uri = window.location.href;

      await queryGeneratePowerpoint({
        id,
        filters,
        rank,
        promo_uri,
      }).unwrap();
    } catch (e) {
      console.error("Error fetching raw data", e);
    }
  };

  if (error) return <Text color="red.500">Error loading data</Text>;

  return (
    <Button onClick={handleDownload} isLoading={isLoading}>
      Export to PowerPoint
    </Button>
  );
}
